export default __webpack_public_path__ + "static/media/studyMaterialIcon.fe87b139.svg";